// Room codes: what a host reads out and a friend types to join.
//
// Real words are easier to say, spell and remember than random letters
// ("FROG", not "BQXPL"). The list is Couch Blocks' hand-picked one: nothing
// rude or grim, no word that sounds like another spelling (BEAR/BARE,
// PEAR/PAIR) or hides a silent letter (LAMB, KNEE), so hearing it is enough
// to type it. Rooms only live while someone is playing, so a few hundred
// words is plenty; after WORD_TRIES taken words the caller's retry loop gets
// random letters instead, with no 0/O, 1/I/L and no digits at all.
//
// Shared byte-identical across the hub's games - edit it in all of them.

export const ROOM_WORDS = [
  'ACRE', 'ALPS', 'APEX', 'ARCH', 'ATOM', 'AXLE', 'BAKE', 'BAND', 'BARK', 'BARN', 'BASE', 'BATH',
  'BEAD', 'BEAN', 'BEEP', 'BELT', 'BEND', 'BIBS', 'BIKE', 'BIRD', 'BLOT', 'BLUR', 'BOAT', 'BOLD',
  'BOLT', 'BOOK', 'BOOM', 'BOOT', 'BOWL', 'BRAG', 'BREW', 'BRIE', 'BUGS', 'BULL', 'BUMP', 'BUNK',
  'BUSH', 'BUSY', 'BUZZ', 'CAKE', 'CALF', 'CAMP', 'CAPE', 'CARD', 'CARP', 'CART', 'CASH', 'CAVE',
  'CHAI', 'CHAT', 'CHEF', 'CHEW', 'CHIP', 'CITY', 'CLAM', 'CLAP', 'CLAW', 'CLIP', 'CLUB', 'CLUE',
  'COAT', 'COIL', 'COIN', 'COLA', 'COLT', 'CONE', 'COOL', 'COPY', 'CORK', 'CORN', 'COVE', 'COZY',
  'CRAB', 'CRIB', 'CROW', 'CUBE', 'CUBS', 'CUFF', 'CURL', 'DAMP', 'DARK', 'DART', 'DASH', 'DAWN',
  'DEAL', 'DECK', 'DEMO', 'DESK', 'DIAL', 'DICE', 'DILL', 'DIME', 'DIRT', 'DISH', 'DIVE', 'DOCK',
  'DOLL', 'DOME', 'DOOR', 'DOTS', 'DRAW', 'DRIP', 'DRUM', 'DUCK', 'DUET', 'DUNE', 'DUSK', 'DUST',
  'EASY', 'ECHO', 'EDGE', 'EGGS', 'EMUS', 'EPIC', 'FACE', 'FARM', 'FAST', 'FAWN', 'FERN', 'FETA',
  'FIGS', 'FILM', 'FIRE', 'FISH', 'FIZZ', 'FLAG', 'FLAT', 'FLEX', 'FLIP', 'FOAM', 'FOLD', 'FOLK',
  'FONT', 'FORK', 'FORT', 'FROG', 'FUEL', 'FUND', 'FUZZ', 'GAME', 'GEAR', 'GIFT', 'GLAD', 'GLEN',
  'GLOW', 'GLUE', 'GOAL', 'GOAT', 'GOLD', 'GOLF', 'GOWN', 'GRAB', 'GRID', 'GRIN', 'GULP', 'GUST',
  'HALF', 'HALO', 'HAND', 'HARP', 'HAWK', 'HELP', 'HERB', 'HERO', 'HIKE', 'HILL', 'HIVE', 'HOOK',
  'HOOP', 'HOPS', 'HORN', 'HOST', 'HUGE', 'HUSH', 'IBIS', 'IDEA', 'INCH', 'INKS', 'ITEM', 'JADE',
  'JAZZ', 'JEEP', 'JOKE', 'JUGS', 'JULY', 'JUMP', 'JUNE', 'KALE', 'KELP', 'KEYS', 'KIND', 'KING',
  'KITE', 'KIWI', 'LACE', 'LADY', 'LAKE', 'LAMP', 'LAND', 'LANE', 'LAVA', 'LAWN', 'LEAF', 'LIFT',
  'LILY', 'LIME', 'LINK', 'LION', 'LIST', 'LOAF', 'LOCK', 'LOFT', 'LOGS', 'LOON', 'LOOP', 'LOUD',
  'LUCK', 'LUMP', 'MALT', 'MAPS', 'MARK', 'MASK', 'MATH', 'MEGA', 'MELT', 'MEMO', 'MENU', 'MESA',
  'MICE', 'MILE', 'MILK', 'MIND', 'MINK', 'MINT', 'MOLE', 'MOOD', 'MOON', 'MOPS', 'MOSS', 'MOTH',
  'MUGS', 'MULE', 'NAIL', 'NAPS', 'NAVY', 'NEAT', 'NECK', 'NEST', 'NEWT', 'NICE', 'NOOK', 'NOON',
  'NOTE', 'OATS', 'OKRA', 'OPAL', 'ORCA', 'OVAL', 'OVEN', 'PACK', 'PADS', 'PAGE', 'PALS', 'PANS',
  'PARK', 'PATH', 'PEST', 'PIES', 'PINE', 'PINK', 'PIPE', 'PITA', 'PLAN', 'PLOT', 'PLUG', 'PLUM',
  'POEM', 'POET', 'POND', 'PONG', 'PONY', 'POOL', 'PORK', 'POTS', 'PROP', 'PUFF', 'PUMA', 'PUMP',
  'PUNS', 'PUPS', 'QUIZ', 'RACE', 'RAFT', 'RAKE', 'RAMP', 'REEF', 'REST', 'RIBS', 'RICE', 'RIDE',
  'RIFT', 'RIMS', 'RINK', 'RISK', 'ROBE', 'ROCK', 'ROOF', 'RUBY', 'RUST', 'SAFE', 'SAGA', 'SAGE',
  'SALT', 'SAND', 'SCAN', 'SEAL', 'SEAT', 'SHED', 'SHIP', 'SHOP', 'SILK', 'SILO', 'SKID', 'SKIP',
  'SKIS', 'SLAB', 'SLED', 'SLIM', 'SLOT', 'SLOW', 'SLUG', 'SMOG', 'SNAP', 'SNOW', 'SNUG', 'SOAP',
  'SOCK', 'SODA', 'SOFA', 'SOFT', 'SONG', 'SOUP', 'SPAN', 'SPIN', 'SPOT', 'SPUD', 'STAR', 'STEM',
  'STEP', 'STEW', 'SUIT', 'SWAN', 'SWAP', 'SWAY', 'SWIM', 'TACO', 'TALK', 'TALL', 'TAME', 'TANK',
  'TAPE', 'TAPS', 'TART', 'TAXI', 'TEAL', 'TENT', 'TEXT', 'THUD', 'TICK', 'TILE', 'TINY', 'TOFU',
  'TOOL', 'TOPS', 'TOSS', 'TOTS', 'TOWN', 'TOYS', 'TRAM', 'TRAY', 'TREE', 'TREK', 'TRIM', 'TRIO',
  'TRIP', 'TROT', 'TUBA', 'TUBE', 'TUFT', 'TUNA', 'TUNE', 'TUSK', 'TWIG', 'TWIN', 'UNDO', 'UNIT',
  'VASE', 'VAST', 'VERB', 'VEST', 'VIEW', 'VINE', 'VOLT', 'VOTE', 'WAGE', 'WALK', 'WALL', 'WAND',
  'WARM', 'WARP', 'WASP', 'WAVE', 'WAVY', 'WEBS', 'WELL', 'WEST', 'WHIP', 'WICK', 'WIDE', 'WIGS',
  'WILD', 'WILT', 'WING', 'WINK', 'WIPE', 'WIRE', 'WISH', 'WOLF', 'WORD', 'WORM', 'YAKS', 'YARD',
  'YARN', 'YAWN', 'YELL', 'YELP', 'YOYO', 'ZANY', 'ZERO', 'ZEST', 'ZINC', 'ZIPS', 'ZONE', 'ZOOM',
];

export const WORD_TRIES = 6;

const LETTERS = 'ABCDEFGHJKMNPQRSTUVWXYZ';

const pick = (list) => list[Math.floor(Math.random() * list.length)];

// `attempt` is how many codes the caller has already found taken.
export function generateRoomCode(attempt = 0) {
  if (attempt < WORD_TRIES) return pick(ROOM_WORDS);
  let code = '';
  for (let i = 0; i < 4; i += 1) code += pick(LETTERS);
  return code;
}

// Digits survive so a room made before the words still joins.
export function normalizeRoomCode(input) {
  return String(input || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}
